import Loader from "react-loader-spinner";
import React, { useMemo, useState, useEffect } from "react";
import {
    Button,
    Form,
    ListGroup,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import { createCredential, getPageList } from "../../store/api/ApiCredentialsApi";
import "./ApiClientPermission.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faTrash, faUniversalAccess, faUserCheck, faUserLock } from "@fortawesome/free-solid-svg-icons";
import { PencilFill, PlusLg } from "react-bootstrap-icons";
import { setErrorDialog } from "../../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

export default function ApiClientPermissionPopover({
    value = [],
    onChange
}) {

    const emptyPermission = {
        pageID: 0,
        pageName: "",
        IsRead: false,
        IsSave: false,
        IsUpdate: false,
        IsDelete: false
    };
    const dispatch = useDispatch();
    const [pages, setPages] = useState([]);
    const [selectedPageID, setSelectedPageID] = useState("");
    const [name, setName] = useState("");

    const [permission, setPermission] = useState(emptyPermission);
    const [permissions, setPermissions] = useState([...value ?? []]);
    const [result, setResult] = useState(null);
    const [isPending, setIsPending] = useState(false);

    const editingPermission = useMemo(() => {
        return permissions.find(p => Number(p.PageID) === Number(selectedPageID));
    }, [permissions, selectedPageID]);



    const save = () => {

        if (!permission.PageID)
            return;

        setPermissions(prev => {
            const index = prev.findIndex(p => p.PageID === permission.PageID);

            if (index >= 0) {
                prev[index] = permission;
            }
            else {
                prev.push(permission);
            }
            const list = [...prev];
            onChange?.(list);
            return list;
        })



    };

    const remove = (pageID) => {

        if (Number(selectedPageID) === Number(pageID)) {

            setSelectedPageID("");
            setPermission(emptyPermission);

        }
        setPermissions(prev => {
            const list = prev.filter(p => p.PageID !== pageID);
            onChange?.(list);
            return list;
        })

    };
    const handleSubmit = async () => {
        if (isPending) {
            return;
        }
        if (!name) {
            return;
        }
        if (!permissions || permissions.length === 0) {
            return;
        }
        const data = {
            Name: name,
            Permissions: permissions

        }
        setIsPending(true);
        const result = await createCredential(data);
        setIsPending(false);
        if (result?.Data) {
            setResult(result.Data);
            clear(true);
        }
        else if (result?.Message) {
            setErrorDialog(dispatch, result.Message, "مدیریت دسترسی به Api", 10000);
        }

    }
    const clear = (afterSubmit) => {
        if (!afterSubmit) {
            setResult(null);
        }
        setPermissions([...value]);
        setSelectedPageID("");
        setPermission(emptyPermission);
        setName("");
    }
    useEffect(() => {

        if (!selectedPageID) {
            setPermission(emptyPermission);
            return;
        }

        const page = pages.find(p => Number(p.ID) === Number(selectedPageID));

        if (!page)
            return;

        if (editingPermission) {

            setPermission({
                ...editingPermission
            });

        } else {

            setPermission({
                PageID: page.ID,
                PersianName: page.PersianName,
                IsRead: false,
                IsSave: false,
                IsUpdate: false,
                IsDelete: false
            });

        }

    }, [selectedPageID, editingPermission]);
    const getPList = async () => {
        const resul = await getPageList();
        if (resul.Data) {
            setPages(resul.Data);
        }
    }
    useEffect(() => {
        getPList();
    }, [])

    const pop = (
        <Popover style={{ minWidth: 420 }} className="client-permission-popover">

            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faUserLock} size="lg" />&nbsp;

                مدیریت دسترسی به Api

            </Popover.Title>

            <Popover.Content className="bodyStyle">
                {result ?
                    <div className="rowBorder p-2 mb-1 mt-2">
                        <p>برای دسترسی به API،  دو ردیف زیر را به سرآیند درخواست اضافه کنید: </p>
                        <label className="credential-result">X-Api-Key: {result.ApiKey}</label>
                        <label className="credential-result">X-Api-Secret: {result.ApiSecret}</label>
                    </div> :
                    <>
                        <Form.Group>
                            <label>نام دسترسی:</label>
                            <Form.Control as="select" onChange={e => setName(e.target.value)}>
                                <option value="">انتخاب کنید</option>
                                <option value="VoipCallManager">مدیریت تماس‌های VOIP</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <label>انتخاب صفحه:</label>

                            <Form.Control
                                as="select"
                                value={selectedPageID}
                                onChange={(e) => setSelectedPageID(e.target.value)}                    >

                                <option value="">انتخاب کنید...</option>

                                {
                                    pages.map(p => <option key={p.ID} value={p.ID} > {p.PersianName} </option>)
                                }

                            </Form.Control>

                        </Form.Group>

                        <div className="mt-3">
                            <Form.Check
                                label="خواندن"
                                id="chkIsRead"
                                disabled={!selectedPageID || !name}
                                checked={permission.IsRead}
                                onChange={e =>
                                    setPermission({
                                        ...permission,
                                        IsRead: e.target.checked
                                    })
                                }
                            />
                            <Form.Check
                                label="ایجاد"
                                id="chkIsSave"
                                disabled={!selectedPageID || !name}
                                checked={permission.IsSave}
                                onChange={e =>
                                    setPermission({
                                        ...permission,
                                        IsSave: e.target.checked
                                    })
                                }
                            />
                            <Form.Check
                                label="بروزرسانی"
                                id="chkIsUpdate"
                                disabled={!selectedPageID || !name}
                                checked={permission.IsUpdate}
                                onChange={e =>
                                    setPermission({
                                        ...permission,
                                        IsUpdate: e.target.checked
                                    })
                                }
                            />
                            <Form.Check
                                label="حذف"
                                id="chkIsDelete"
                                checked={permission.IsDelete}
                                disabled={!selectedPageID || !name}
                                onChange={e =>
                                    setPermission({
                                        ...permission,
                                        IsDelete: e.target.checked
                                    })
                                }
                            />
                        </div>

                        <Button
                            className="mt-2"
                            variant={editingPermission ? "warning" : "primary"}
                            onClick={save}
                            disabled={!selectedPageID || !name}
                        >
                            {editingPermission ? <PencilFill size={12} /> : <PlusLg size={14} />}&nbsp;
                            {
                                editingPermission
                                    ? "ویرایش"
                                    : "افزودن"
                            }

                        </Button>
                        <hr />
                        <ListGroup>
                            {
                                permissions.map(item =>
                                    <ListGroup.Item
                                        key={item.pageID}
                                        className="client-permission-row"
                                    >
                                        <div>
                                            <b>{item.pageName}</b>
                                            <div className="client-permission-tags">
                                                {item.IsRead && <span>خواندن</span>}
                                                {item.IsSave && <span>ایجاد</span>}
                                                {item.IsUpdate && <span>بروزرسانی</span>}
                                                {item.IsDelete && <span>حذف</span>}
                                            </div>
                                        </div>
                                        <FontAwesomeIcon icon={faTimes} size="2x" color="red" onClick={() => remove(item.PageID)} />
                                    </ListGroup.Item>
                                )
                            }

                        </ListGroup>

                        <Button className="group-Btn-large" variant="info" onClick={handleSubmit} disabled={isPending}>
                            {isPending ?
                                <Loader type="TailSpin" color="green" width={16} height={16} style={{ display: "inline-block" }} /> :
                                <FontAwesomeIcon icon={faCheck} size="lg" />}
                            &nbsp;
                            ثبت نهایی تغییرات
                        </Button>
                    </>}
            </Popover.Content>

        </Popover>
    )

    return (

        <OverlayTrigger
            trigger="click"
            rootClose
            placement="left"
            overlay={pop}

        >

            <Button className="group-Btn" onClick={() => clear(false)}>
                <FontAwesomeIcon icon={faUserLock} size="lg" />&nbsp;
                مدیریت دسترسی به Api

            </Button>

        </OverlayTrigger>

    );

}